export const MONTH_NONE = 'NONE';
export const VALID_EMAIL_REGEXP =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const VALID_URL_REGEXP =
  /^(http(s)?):\/\/(www.)?[?a-zA-Z0-9@:%._+~#=]+(\.[a-z]{2,}){1,3}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)$/;
